// extracted by mini-css-extract-plugin
export var boldText = "_2w-4";
export var checkboxContainer = "_2w-6";
export var closeIcon = "_2w-g";
export var container = "_2w-0";
export var drawer = "_2w-8";
export var drawerContent = "_2w-9";
export var extraSmallText = "_2w-5";
export var fulfillmentGroupTable = "_2w-e";
export var largeText = "_2w-3";
export var loadingSpinnerContainer = "_2w-h";
export var mediumText = "_2w-2";
export var narrow = "_2w-f";
export var notificationLink = "_2w-j";
export var packageCheckIconContainer = "_2w-7";
export var slideoutHeaderContainer = "_2w-a";
export var slideoutModal = "_2w-c";
export var stickyHeaderWrapper = "_2w-b";
export var table = "_2w-i";
export var tableContainer = "_2w-d";
export var tertiaryText = "_2w-1";